// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 482 ? "FluidFramework-HashFallback" : chunkId) + "." + {"189":"9438f376","482":"956e55d6"}[chunkId] + ".js";
};